import { useCallback } from 'react';
import { BaseComponent, Building } from '../../types/protocols';
import { BaseComponentImpl } from '../../types/implementations';
import { BuildingCheck, checkDisplayName } from '../../Pages/BuildingChecks/buildingChecksUtils';

/**
 * The name a check shows for its component: the component's display name (the building
 * page's naming rule), from a raw component node, so pages without the building's model
 * name it the same. Undefined when the component is gone or archived.
 */
export const checkComponentName = (component: BaseComponent | null | undefined): string | undefined => {
    if (!component || component.archivedAt) return undefined;
    return new BaseComponentImpl(component).displayName() || undefined;
};

/** `checkComponentName` of a component of the building. */
export const componentNameIn = (building: Building | null | undefined, componentKey: string): string | undefined =>
    checkComponentName(building?.model?.structure?.components?.[componentKey]);

/**
 * `checkDisplayName` with the building's live component names ("Brandsläckare – Plan 2 trapphus"),
 * for pages that show one building's checks.
 */
export const useCheckName = (building: Building | null | undefined) =>
    useCallback(
        (check: Pick<BuildingCheck, 'label' | 'componentKey'>, templateName: string) =>
            checkDisplayName(check, templateName, {
                componentName: key => componentNameIn(building, key)
            }),
        [building]
    );
